import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import "../style/Nav.css";
import { NavLink } from "react-router-dom";
import MobileMenu from "../components/MobileMenu";
import { connect } from "react-redux";
import * as actions from "../actions";
class Nav extends Component {
  constructor(props) {
    // Nav.js receives toggleAuthentication: function and authenticated: Boolean
    super(props);
    this.state = {
      mobileMenuOpen: true,
      signedIn: false,
      redirect: false
    };
    this.signOut = this.signOut.bind(this);
  }
  componentDidMount() {
    if (localStorage.getItem("token")) {
      this.setState({ signedIn: true });
    }
  }
  renderNavItems(navItems) {
    return navItems.map(navItem => {
      return (
        <div key={navItem.title} className="nav-item">
          <NavLink to={navItem.url}>{navItem.title}</NavLink>
        </div>
      );
    });
  }
  signOut() {
    localStorage.removeItem("token");
    this.props.deAuth();
  }
  render() {
    const navItems = [
      { title: "Home", url: "/" },
      { title: "About", url: "/about" },
      { title: "Contact", url: "/contact" }
    ];
    return (
      <div>
        <div className="nav">
          <div className="nav-logo">
            <NavLink to="/">
              <h1>English Motets</h1>
            </NavLink>
          </div>
          <div className="nav-list">
            {this.renderNavItems(navItems)}
            {this.props.authenticated && (
              <div className="nav-item nav-item--sign-out">
                <a onClick={this.signOut}>Sign out</a>
              </div>
            )}
            {/* CLIENT-SIDE REDIRECTION FROM DASHBOARD */}
            {!this.props.authenticated &&
              window.location.pathname === "/dashboard" && <Redirect to="/" />}
          </div>
        </div>
        <MobileMenu navItems={navItems} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    authenticated: state.authenticated
  };
};

export default connect(
  mapStateToProps,
  actions
)(Nav);



// WEBPACK FOOTER //
// ./src/components/Nav.js